import { Component, OnInit, ViewChild } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { MatPaginator } from "@angular/material/paginator";
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { Router } from "@angular/router";
import { EncrDecrService } from "src/app/AuthGuard/EncrDecrService";
import { DataSharingService } from "../../AuthGuard/DataSharingService";
import { MasterService } from "../../Shared/app.Masters.Service";
import { LosService } from "../../_LOS/services/los.service";
import { LmsService } from "../../_Lms/services/lms.service";
import { SnackbarComponent } from "../../snackbar/snackbar.component";
import { QuickLoanService } from "../services/quickLoan.service";
declare var $: any;

@Component({
    selector: "app-quickloan-dashboard",
    templateUrl: "./quickloan-dashboard.component.html",
    styleUrls: ["./quickloan-dashboard.component.scss"],
    standalone: false
})
export class QuickLoanDashboardComponent implements OnInit {
  DateFrom: any = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
  DateTo: any = new Date();
  BranchesList: any[] = [];
  BranchId: any = 0;
  maxDate: Date = new Date();
  currentUser: any;
  index: any;
  showSpinner: boolean = false;
  showTable: boolean = false;
  loading: boolean = false;
  teamListData: any[] = [];
  searchTeamQuery: string = "";
  searchProcessQuery: string = "";
  dashboardData: any[] = [];
  dashboardReportData: any[] = [];
  iconname: string = "../../assets/images/";
  stateDropdown: any[] = [];
  showSelfEnquiry: boolean = false;
  districkDropdown: any[] = [];
  tehasilDropdown: any[] = [];
  inquiryModel: any = {};
  tab: any = "mytask";
  IsRegisterInquiry: boolean = false;
  tab1: any;
  configSuccess: MatSnackBarConfig = {
    panelClass: "style-success",
    duration: 5000,
    horizontalPosition: "right",
    verticalPosition: "top",
  };
  leadSourceDropdown: any[] = [];
  AddLoan: boolean = true;
  isSelsPerson: boolean = false;
  partnerDropdown: any[] = [];
  employeeBranchDropdown: any[] = [];
  processListData: any[] = [];
  selectedProcess: any;
  dataProcessSource: any;
  camLoanId: any;
  displayedProcessColumns: string[] = [
    "ApplicationId",
    "Application_No",
    "Application_Date",
    "Customer",
    "Product_Name",
    // "Application_LoanAmount",
    "Required_Amount",
    "Sanctioned_Approved_Amount",
    "ApprovalStatus",
    "Branch_Name",
    "EmpName",
    "SourceType",
    "SourceName",
    "AssignOn",
    "AP_ProcessStatus",
    "TAT_Hr",
  ];
  Status = "Pending";
  JsonData: any[] = [];

  JsonDataTeam: any[] = [];
  dataTeamSource: any;
  displayedTeamColumns: string[] = [
    "ApplicationId",
    "Application_No",
    "Application_Date",
    "Customer",
    "Product_Name",
    // "Application_LoanAmount",
    "Required_Amount",
    "Sanctioned_Approved_Amount",
    "ApprovalStatus",
    "Branch_Name",
    "Process_Name",
    "SourceType",
    "SourceName",
    "AssignOn",
    "AP_ProcessStatus",
    "TAT_Hr",
  ];
  selectedTeam: any;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(
    private QuickLoanService: QuickLoanService,
    private dataSharingService: DataSharingService,
    private _Route: Router,
    private _MasterService: MasterService,
    private _EncrDecrService: EncrDecrService,
    private losService: LosService,
    private snackBar: MatSnackBar,
    private lmsService: LmsService,
    public dialog: MatDialog
  ) { }

  ngOnInit() {
    this.dataSharingService.HeaderTitle.next("QuickLoan Dashboard");
    this.currentUser = JSON.parse(sessionStorage.getItem("currentUser"));
    // Restore last used report dates from sessionStorage if available
    const lastReportDateFrom = sessionStorage.getItem("lastReportDateFrom");
    const lastReportDateTo = sessionStorage.getItem("lastReportDateTo");
    if (lastReportDateFrom) {
      this.DateFrom = new Date(lastReportDateFrom);
    } else {
      this.DateFrom = new Date(
        new Date().getFullYear(),
        new Date().getMonth(),
        1
      );
    }
    if (lastReportDateTo) {
      this.DateTo = new Date(lastReportDateTo);
    } else {
      this.DateTo = new Date();
    }
    if (new Date(this.currentUser.SubscriptionDate) <= new Date()) {
      this.AddLoan = false;
    } else {
      this.AddLoan = true;
    }
    this.inquiryModel = {
      Source: "",
      CustomerState: "",
      CustomerDistrict: "",
      CustomerTehsil: "",
      InquirySelfAssigned: false,
      LeadReference: "",
      BranchId: "",
      LoginUserId: this.currentUser.userId,
    };
    this.GetQuickLoanDashboardCount();
    this.getLeadSourceDropdown();
    this.GetStateDropdown();
    this.Get_EmployeeBranchForDropdown();
    //this.getBranchesList();
  }

  GetQuickLoanDashboardCount() {
    this.showSpinner = true;
    this.QuickLoanService.GetQuickLoanDashboardCount({
      LoginUserId: this.currentUser.userId,
    }).subscribe((res: any) => {
      if (res.length > 0) {
        this.dashboardData = res;
        this.showSpinner = false;
        this.IsRegisterInquiry = res.some((item) => item.EmpProcessId == 12);
      } else {
        this.dashboardData = [];
        this.showSpinner = false;
      }
    });
  }
  getTotalRequiredAmountTeam() {
    return (this.dataTeamSource?.data || [])
      .map((t: any) => Number(t.Required_Amount) || 0)
      .reduce((acc, value) => acc + value, 0);
  }
  getTotalSanctionedAmountTeam() {
    return (this.dataTeamSource?.data || [])
      .map((t: any) => Number(t.Sanctioned_Approved_Amount) || 0)
      .reduce((acc, value) => acc + value, 0);
  }
  getTotalRequiredAmount() {
    return (this.dataProcessSource?.data || [])
      .map((t: any) => Number(t.Required_Amount) || 0)
      .reduce((acc, value) => acc + value, 0);
  }
  getTotalSanctionedAmount() {
    return (this.dataProcessSource?.data || [])
      .map((t: any) => Number(t.Sanctioned_Approved_Amount) || 0)
      .reduce((acc, value) => acc + value, 0);
  }
  fromDateFilter = (d: Date | null): boolean => {
    const date = d || new Date();
    // Allow only dates up to today, and before 'To Date' if it's selected
    if (this.DateTo) {
      return date <= this.maxDate && date <= this.DateTo;
    }
    return date <= this.maxDate;
  };

  toDateFilter = (d: Date | null): boolean => {
    const date = d || new Date();
    if (this.DateFrom) {
      return date <= this.maxDate && date >= this.DateFrom;
    }
    return date <= this.maxDate;
  };
  getBranchesList() {
    this.lmsService
      .GetBranches({ Emp_Id: this.currentUser.userId })
      .subscribe((result) => {
        this.BranchesList = JSON.parse(JSON.stringify(result));
      });
  }

  onSearchReportsSummary() {
    this.QuickLoan_LOS_Reports_Summary();
  }

  goToPage(data) {
    console.log("data", data);
    if (data.EmpProcessId == 5) {
      this._Route.navigate([
        `quickloan-dashboard/quick-loan/DeviationList/${this._EncrDecrService.encrypt(
          encodeURIComponent(data.EmpProcessId)
        )}`,
      ]);
    } else if (data.EmpProcessId == 13) {
      this._Route.navigate([`quickloan-dashboard/quick-loan/inquiry/`]);
    } else if (data.EmpProcessId == 12) {
      this._Route.navigate([`quickloan-dashboard/quick-loan/my-lead/`]);
    } else {
      this._Route.navigate([
        `quickloan-dashboard/quick-loan/list/${this._EncrDecrService.encrypt(
          encodeURIComponent(data.EmpProcessId)
        )}/${this._EncrDecrService.encrypt(
          encodeURIComponent(data.EmpProcessName)
        )}`,
      ]);
    }
  }
  goToPageReports(data) {
    // Map ReportId 1-12 to reportIndex 0-11
    if (data.ReportId >= 1 && data.ReportId <= 12) {
      const fromDate = this.formatDateToYMD(this.DateFrom);
      const toDate = this.formatDateToYMD(this.DateTo);
      console.log("reportIndex", data.ReportId, fromDate, toDate);
      this._Route.navigate([
        `quickloan-dashboard/losreports/${this._EncrDecrService.encrypt(
          encodeURIComponent(data.ReportId)
        )}/${this._EncrDecrService.encrypt(
          encodeURIComponent(data.ReportName)
        )}/${this._EncrDecrService.encrypt(
          encodeURIComponent(fromDate)
        )}/${this._EncrDecrService.encrypt(encodeURIComponent(toDate))}`,
      ]);
    } else {
      // Optionally handle invalid ReportId
      this.snackBar.open("Invalid ReportId", "", { duration: 2000 });
    }
  }
  onOpenNewInquiryModel() {
    if (this.dashboardData.find((item) => item.EmpProcessId == 1)) {
      this.showSelfEnquiry = true;
      $("#addNewInquiry").modal("show");
      $("#addNewInquiry").css("z-index", "1050");
    } else {
      this.showSelfEnquiry = false;
      $("#addNewInquiry").modal("show");
      $("#addNewInquiry").css("z-index", "1050");
    }
  }
  OnClose() {
    this.inquiryModel = {};
    $("#addNewInquiry").modal("hide");
  }
  getLeadSourceDropdown() {
    this.losService.getLeadSourceDropdown({}).subscribe((res: any) => {
      this.leadSourceDropdown = res;
    });
  }
  onSaveInquiry() {
    this.loading = true;
    this.inquiryModel.InquirySelfAssigned = this.inquiryModel
      .InquirySelfAssigned
      ? 1
      : 0;
    if (+this.inquiryModel.LoanAmount <= 0) {
      this.snackBar.openFromComponent(SnackbarComponent, {
        data: "Loan Amount should be greater than 0.",
        ...this.configSuccess,
      });
      return;
    }
    this.losService
      .saveNewInquiry({ JSON: JSON.stringify({ Inquiry: this.inquiryModel }) })
      .subscribe((res: any) => {
        this.loading = false;
        if (res[0].CODE == 0) {
          this.snackBar.openFromComponent(SnackbarComponent, {
            data: res[0].MSG,
            ...this.configSuccess,
          });
          this.GetQuickLoanDashboardCount();
          this.OnClose();
        } else {
          this.snackBar.openFromComponent(SnackbarComponent, {
            data: res[0].MSG,
            ...this.configSuccess,
          });
        }
      });
  }
  GetStateDropdown() {
    this.losService.GetStateDropdown({}).subscribe((res: any) => {
      this.stateDropdown = res;

      if (this.inquiryModel.CustomerState != "") this.GetDistrickDropdown();
    });
  }
  GetDistrickDropdown() {
    this.inquiryModel.CustomerDistrict = "";
    this.inquiryModel.CustomerTehsil = "";
    if (this.inquiryModel.CustomerState != "") {
      let _find = this.stateDropdown.find((obj: any) => {
        return (
          obj.State_Name.toUpperCase() ==
          this.inquiryModel.CustomerState.toUpperCase()
        );
      });

      this.losService
        .GetDistrickDropdown({ StateID: _find.StateId })
        .subscribe((res: any) => {
          this.districkDropdown = res;
        });
    }
  }
  GetTehasilDropdown() {
    let _find = this.districkDropdown.find((obj: any) => {
      return obj.District_Name == this.inquiryModel.CustomerDistrict;
    });
    this.inquiryModel.CustomerTehsil = "";
    this.losService
      .GetTehasilDropdown({ DistrictId: _find.DistrictId })
      .subscribe((res: any) => {
        this.tehasilDropdown = res;
      });
  }
  onChangeSource() {
    this.inquiryModel.LeadReference = "";
    if (
      this.inquiryModel.Source == "Agent" ||
      this.inquiryModel.Source == "DSA" ||
      this.inquiryModel.Source == "Dealer"
    ) {
      this.Get_PartnerForDropdown();
    }
  }
  Get_PartnerForDropdown() {
    this.losService
      .Get_PartnerForDropdown({
        PartnerType: this.inquiryModel.Source,
        loginUserId: this.currentUser.userId
      })
      .subscribe((res: any) => {
        this.partnerDropdown = res;
      });
  }
  Get_EmployeeBranchForDropdown() {
    this._MasterService
      .Get_EmployeeBranchForDropdown({ EmployeeId: this.currentUser.userId, partnerId: this.inquiryModel.LeadReference ? this.inquiryModel.LeadReference : 0 })
      .subscribe((res: any) => {
        this.employeeBranchDropdown = res;
      });
  }
  QuickLoan_LOS_Reports_Summary() {
    this.showSpinner = true;
    const fromDate = this.formatDateToYMD(this.DateFrom);
    const toDate = this.formatDateToYMD(this.DateTo);
    // Save last used dates to sessionStorage
    sessionStorage.setItem("lastReportDateFrom", this.DateFrom);
    sessionStorage.setItem("lastReportDateTo", this.DateTo);
    this.QuickLoanService.QuickLoan_LOS_Reports_Summary({
      LoginUserId: this.currentUser.userId,
      FromDate: fromDate,
      To: toDate,
    }).subscribe((res: any) => {
      this.dashboardReportData = res;
      this.showSpinner = false;
    });
  }

  changeTab(tab: any) {
    if (tab !== this.tab) {
      this.tab = tab;
      this.selectedTeam = undefined;
      this.selectedProcess = undefined;
      this.searchTeamQuery = "";
      this.searchProcessQuery = "";
      $(".filterInput").val("");

      if (tab === "mytask") {
        this.GetQuickLoanDashboardCount();
      } else if (tab === "team") {
        this.Quick_Loan_Get_Manager_Dashboard_ByTeam();
        this.getBranchesList();
        this.DateFrom = "";
        this.DateTo = "";
      } else if (tab === "process") {
        this.Quick_Loan_GetManagerDashboardByProcess();
        this.getBranchesList();
        this.DateFrom = "";
        this.DateTo = "";
      } else if (tab === "reports") {
        this.DateFrom = new Date(
          new Date().getFullYear(),
          new Date().getMonth(),
          1
        );
        this.DateTo = new Date();
        this.QuickLoan_LOS_Reports_Summary();
      }
    }
  }

  getTeamDetail(item: any) {
    if (this.selectedTeam?.EmpId === item.EmpId) {
      this.selectedTeam = null;
      this.dataTeamSource = new MatTableDataSource([]);
      this.showTable = false;
      return;
    }

    this.showSpinner = true;
    this.selectedTeam = item;
    this.showTable = true;

    this.QuickLoanService.Quick_Loan_Get_Manager_Dashboard_ByTeam({
      ManagerId: this.currentUser.userId,
      TeamMemberId: item.EmpId,
      From_Date: this.DateFrom,
      To_Date: this.DateTo,
      BranchId: this.BranchId,
    }).subscribe((res: any) => {
      this.dataTeamSource = new MatTableDataSource(res.Item2);
      this.JsonDataTeam = res.Item2;
      this.dataTeamSource.sort = this.sort;
      this.dataTeamSource.paginator = this.paginator;
      this.showSpinner = false;
    });
    this.DateFrom = "";
    this.DateTo = "";
    this.BranchId = 0;
  }

  onChangeTeamDetail() {
    if (!this.selectedTeam) {
      return;
    }
    this.showSpinner = true;
    this.QuickLoanService.Quick_Loan_Get_Manager_Dashboard_ByTeam({
      ManagerId: this.currentUser.userId,
      TeamMemberId: this.selectedTeam.EmpId,
      From_Date: this.DateFrom,
      To_Date: this.DateTo,
      BranchId: this.BranchId,
    }).subscribe((res: any) => {
      this.dataTeamSource = new MatTableDataSource(res.Item2);
      this.JsonDataTeam = res.Item2;
      this.dataTeamSource.sort = this.sort;
      this.dataTeamSource.paginator = this.paginator;
      this.showSpinner = false;
    });
    this.DateFrom = "";
    this.DateTo = "";
    this.BranchId = 0;
  }

  Quick_Loan_Get_Manager_Dashboard_ByTeam() {
    this.showSpinner = true;
    this.QuickLoanService.Quick_Loan_Get_Manager_Dashboard_ByTeam({
      ManagerId: this.currentUser.userId,
      TeamMemberId: "0",
      From_Date: this.DateFrom,
      To_Date: this.DateTo,
      BranchId: this.BranchId,
    }).subscribe((res: any) => {
      this.teamListData = res.Item1;
      this.showSpinner = false;
    });
  }

  Quick_Loan_GetManagerDashboardByProcess() {
    this.showSpinner = true;
    this.QuickLoanService.QuickLoan_Get_Manager_Dashboard_ByProcess({
      ManagerId: this.currentUser.userId,
      ProcessId: "0",
      Status: "Pending",
      From_Date: this.DateFrom,
      To_Date: this.DateTo,
      BranchId: this.BranchId,
    }).subscribe((res: any) => {
      this.processListData = res.Item1;
      this.showSpinner = false;
    });
  }

  getDetail(item: any) {
    // Toggle logic: if same card is clicked again, collapse it
    if (this.selectedProcess?.ProcessId === item.ProcessId) {
      this.selectedProcess = null;
      this.dataProcessSource = new MatTableDataSource([]);
      return;
    }

    this.showSpinner = true;
    this.selectedProcess = item;

    console.log("this.selectedProcess", item.ProcessId);

    this.displayedProcessColumns = [
      "ApplicationId",
      "Application_No",
      "Application_Date",
      "Customer",
      "Product_Name",
      // "Application_LoanAmount",
      "Required_Amount",
      "Sanctioned_Approved_Amount",
      "ApprovalStatus",
      "Branch_Name",
      "SourceType",
      "SourceName",
      "EmpName",
      "AssignOn",
      "AP_ProcessStatus",
      "TAT_Hr",
    ];

    this.QuickLoanService.QuickLoan_Get_Manager_Dashboard_ByProcess({
      ManagerId: this.currentUser.userId,
      ProcessId: item.ProcessId,
      Status: "Pending",
      From_Date: this.DateFrom,
      To_Date: this.DateTo,
      BranchId: this.BranchId,
    }).subscribe((res: any) => {
      this.showSpinner = false;

      if (res.Item2.length > 0) {
        this.dataProcessSource = new MatTableDataSource(res.Item2);
        this.JsonData = res.Item2;
        this.dataProcessSource.sort = this.sort;
        this.dataProcessSource.paginator = this.paginator;
      } else {
        this.dataProcessSource = null;
        this.snackBar.openFromComponent(SnackbarComponent, {
          data: "No Data Found",
          ...this.configSuccess,
        });
      }
    });
  }

  onChangeStatusofProcess() {
    console.log("change of Process Id", this.selectedProcess.ProcessId);

    this.showSpinner = true;

    this.displayedProcessColumns = [
      "ApplicationId",
      "Application_No",
      "Application_Date",
      "Customer",
      "Product_Name",
      // "Application_LoanAmount",
      "Required_Amount",
      "Sanctioned_Approved_Amount",
      "ApprovalStatus",
      "Branch_Name",
      "SourceType",
      "SourceName",
      "EmpName",
      "AssignOn",
      "AP_ProcessStatus",
      "TAT_Hr",
    ];

    this.QuickLoanService.QuickLoan_Get_Manager_Dashboard_ByProcess({
      ManagerId: this.currentUser.userId,
      ProcessId: this.selectedProcess.ProcessId,
      Status: this.Status,
      From_Date: this.DateFrom,
      To_Date: this.DateTo,
      BranchId: this.BranchId,
    }).subscribe((res: any) => {
      if (res.Item2.length > 0) {
        this.dataProcessSource = new MatTableDataSource(res.Item2);
        this.JsonData = res.Item2;
        this.dataProcessSource.sort = this.sort;
        this.dataProcessSource.paginator = this.paginator;

        this.showSpinner = false;
      } else {
        this.dataProcessSource = null;
        this.snackBar.openFromComponent(SnackbarComponent, {
          data: "No Data Found",
          ...this.configSuccess,
        });
        this.showSpinner = false;
      }
    });
    this.showSpinner = false;
    this.DateFrom = "";
    this.DateTo = "";
    this.BranchId = 0;
  }

  applyFilter(filterValue: string) {
    if (
      this.dataProcessSource != undefined &&
      this.dataProcessSource.filteredData.length > 0
    ) {
      this.dataProcessSource.filter = filterValue.trim().toLowerCase();
    }
    if (
      this.dataTeamSource != undefined &&
      this.dataTeamSource.filteredData.length > 0
    ) {
      this.dataTeamSource.filter = filterValue.trim().toLowerCase();
    }
  }

  getFilteredTeamList(): any[] {
    if (!this.teamListData) return [];
    if (!this.searchTeamQuery || !this.searchTeamQuery.trim()) {
      return this.teamListData;
    }
    const q = this.searchTeamQuery.toLowerCase().trim();
    return this.teamListData.filter((item: any) =>
      (item.EmpName || "").toLowerCase().includes(q)
    );
  }

  getFilteredProcessList(): any[] {
    if (!this.processListData) return [];
    if (!this.searchProcessQuery || !this.searchProcessQuery.trim()) {
      return this.processListData;
    }
    const q = this.searchProcessQuery.toLowerCase().trim();
    return this.processListData.filter((item: any) =>
      (item.Process_Name || "").toLowerCase().includes(q)
    );
  }

  exportexcelByProcess(Process_Name): void {
    const uri = "data:application/vnd.ms-excel;base64,";
    const template =
      '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>';
    const base64 = (s: string): string =>
      window.btoa(unescape(encodeURIComponent(s)));
    const format = (s: string, c: { [key: string]: string }): string =>
      s.replace(/{(\w+)}/g, (m, p) => c[p]);

    const table = document.getElementById(
      "quickLoan_Dashboard_export"
    ) as HTMLTableElement;
    const worksheetName = "QUICKLOAN VIEW BY " + Process_Name + " EXPORT"; // Set the desired worksheet name here
    const ctx = { worksheet: worksheetName, table: table.innerHTML };
    const downloadLink = document.createElement("a");

    // Generate the data URI for the Excel file
    downloadLink.href = uri + base64(format(template, ctx));

    // Set the file name for the download
    downloadLink.download = worksheetName + ".xls";

    // Trigger the download
    downloadLink.click();
  }

  exportexcelByTeam(): void {
    const uri = "data:application/vnd.ms-excel;base64,";
    const template =
      '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>';
    const base64 = (s: string): string =>
      window.btoa(unescape(encodeURIComponent(s)));
    const format = (s: string, c: { [key: string]: string }): string =>
      s.replace(/{(\w+)}/g, (m, p) => c[p]);

    const table = document.getElementById(
      "quickLoan_export_byTeam"
    ) as HTMLTableElement;
    const worksheetName = "QUICKLOAN VIEW BY TEAM EXPORT"; // Set the desired worksheet name here
    const ctx = { worksheet: worksheetName, table: table.innerHTML };
    const downloadLink = document.createElement("a");

    // Generate the data URI for the Excel file
    downloadLink.href = uri + base64(format(template, ctx));

    // Set the file name for the download
    downloadLink.download = worksheetName + ".xls";

    // Trigger the download
    downloadLink.click();
  }

  private formatDateToYMD(date: any): string {
    if (!date) return "";
    const d = new Date(date);
    const year = d.getFullYear();
    const month = ("0" + (d.getMonth() + 1)).slice(-2);
    const day = ("0" + d.getDate()).slice(-2);
    return `${year}-${month}-${day}`;
  }
}
